import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import DynamicItem from "../../../components/forms/DynamicItem";
import { FormattedMessage } from "react-intl";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { ReactComponent as IllnessImg } from "../../../assets/no-illness.svg";
import { ReactComponent as MedicineImg } from "../../../assets/no-medicine.svg";
import { ReactComponent as RestrictionImg } from "../../../assets/no-restriction.svg";
import { ReactComponent as DiagnoseImg } from "../../../assets/no-diagnose.svg";

const MedicalInfo = forwardRef((props, ref) => {
  const { smallSpace } = props;
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.medical_information" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="medical_info.health_fund_id"
                  category="patient"
                  metadataName={"health_funds"}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem name="medical_info.clinic_name" category="patient" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem name="medical_info.doctor_name" category="patient" />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <PhoneNumberItem
                  name="medical_info.clinic_phone"
                  category="patient"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="medical_info.psychiatrist_name"
                  category="patient"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <PhoneNumberItem
                  name="medical_info.psychiatrist_phone"
                  category="patient"
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
      <Surface smallSpace={smallSpace}>
        <FormHeader title={<FormattedMessage id="app.patients.illnesses" />} />

        <Row>
          <Col span={24}>
            <DynamicItem
              resource={"patients"}
              action={"editor"}
              emptyImg={<IllnessImg />}
              name="medical_info.deseases"
              category="patient"
              addText={<FormattedMessage id="app.patients.addIllnesse" />}
              tableItems={[
                {
                  title: "name",
                  type: "input",
                  required: true,
                },
                {
                  title: "description",
                  type: "input",
                  required: true,
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.limitations" />}
        />

        <Row>
          <Col span={24}>
            <DynamicItem
              resource={"patients"}
              action={"editor"}
              emptyImg={<RestrictionImg />}
              name="medical_info.limitations"
              category="patient"
              addText={<FormattedMessage id="app.patients.addRestriction" />}
              tableItems={[
                {
                  title: "name",
                  type: "input",
                  required: true,
                },
                {
                  title: "description",
                  type: "input",
                  required: true,
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
      <Surface smallSpace={smallSpace}>
        <FormHeader title={<FormattedMessage id="app.patients.diagnoses" />} />
        <Row>
          <Col span={24}>
            <DynamicItem
              resource={"patients"}
              action={"editor"}
              emptyImg={<DiagnoseImg />}
              name="medical_info.diagnoses"
              category="patient"
              addText={<FormattedMessage id="app.patients.addDiagnose" />}
              tableItems={[
                {
                  title: "name",
                  type: "input",
                  required: true,
                },
                {
                  title: "description",
                  type: "input",
                  required: true,
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
      <Surface smallSpace={smallSpace}>
        <FormHeader title={<FormattedMessage id="app.patients.medicines" />} />
        <Row>
          <Col span={24}>
            <DynamicItem
              resource={"patients"}
              action={"editor"}
              emptyImg={<MedicineImg />}
              name="medical_info.medicines"
              category="patient"
              addText={<FormattedMessage id="app.patients.addMedicine" />}
              tableItems={[
                {
                  title: "name",
                  type: "input",
                  required: true,
                },
                {
                  title: "description",
                  type: "input",
                  required: true,
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default MedicalInfo;
